import { render, staticRenderFns } from "./DashboardStatisticsCard.vue?vue&type=template&id=dbcd17be&scoped=true"
import script from "./DashboardStatisticsCard.vue?vue&type=script&lang=js"
export * from "./DashboardStatisticsCard.vue?vue&type=script&lang=js"
import style0 from "./DashboardStatisticsCard.vue?vue&type=style&index=0&id=dbcd17be&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcd17be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbcd17be')) {
      api.createRecord('dbcd17be', component.options)
    } else {
      api.reload('dbcd17be', component.options)
    }
    module.hot.accept("./DashboardStatisticsCard.vue?vue&type=template&id=dbcd17be&scoped=true", function () {
      api.rerender('dbcd17be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/statistics-cards/DashboardStatisticsCard.vue"
export default component.exports